var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalHistoryEmptyState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 161,
    viewBox: "0 0 240 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1166_79805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4964 118.283H70.9276C63.3514 118.283 57.2148 112.146 57.2148 104.57V29.1503C57.2148 21.574 63.3514 15.4375 70.9276 15.4375H166.916C174.492 15.4375 180.629 21.574 180.629 29.1503V104.57C180.629 112.146 174.492 118.283 166.916 118.283H146.347",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4964 118.283H70.9276C63.3514 118.283 57.2148 112.146 57.2148 104.57V29.1503C57.2148 21.574 63.3514 15.4375 70.9276 15.4375H166.916C174.492 15.4375 180.629 21.574 180.629 29.1503V104.57C180.629 112.146 174.492 118.283 166.916 118.283H146.347",
    stroke: "#D9D8DF",
    strokeWidth: 1.10667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.921 145.702C134.068 145.702 146.347 133.423 146.347 118.277C146.347 103.13 134.068 90.8516 118.921 90.8516C103.775 90.8516 91.4961 103.13 91.4961 118.277C91.4961 133.423 103.775 145.702 118.921 145.702Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6406 58.0973H153.204M84.6406 40.8125H153.204M84.6406 75.4688H153.204",
    stroke: "#D9D8DF",
    strokeWidth: 6.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.921 127.944V108.609M109.254 118.276H128.589",
    stroke: "#FDFDFD",
    strokeWidth: 4.70333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1166_79805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 160,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalHistoryEmptyState);
export default __webpack_public_path__ + "static/media/medical-history-empty-state.ebfd9485426a57bac2223dbc0744a559.svg";
export { ForwardRef as ReactComponent };